import React, { memo, useCallback } from 'react';

import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import i18n from '../messages.json';
import RecipientList from './RecipientList';
import { isRecipientValid } from './recipient-validation';

/**
 * Body content for the Braze channel of the Send Test dialog.
 *
 * The Braze test sends an ad-hoc push via /messages/send, which targets Braze
 * User IDs (external_user_id) and bypasses segment membership (WWW-15543). The
 * recipient list accepts either an email — resolved to a Braze User ID by the
 * lambda via /users/export/ids — or a raw Braze User ID; a tooltip explains both.
 *
 * Props
 *   hasCampaigns:      boolean — the Braze test is gated on a segment being selected
 *   recipients:        string[] — parent state
 *   onRecipientsChange:(next: string[]) => void
 */
const BrazeChannelBody = ({ hasCampaigns, recipients, onRecipientsChange }) => {
  const validator = useCallback(isRecipientValid, []);

  return (
    <>
      {!hasCampaigns && (
        <div className='send-test__warning'>
          {i18n.ink.notification.sendTest.noCampaignsWarning}
        </div>
      )}

      <Form.Group>
        <Form.Label className='send-test__label'>
          {i18n.ink.notification.sendTest.brazeIdRecipients}
          <OverlayTrigger
            placement='top'
            overlay={
              <Tooltip id='send-test-braze-id-help'>
                {i18n.ink.notification.sendTest.brazeIdHelp}
              </Tooltip>
            }
          >
            <button
              type='button'
              className='send-test__help-icon'
              aria-label={i18n.ink.notification.sendTest.brazeIdHelpAria}
            >
              <FontAwesomeIcon icon={faInfoCircle} />
            </button>
          </OverlayTrigger>
        </Form.Label>
        <RecipientList
          list={recipients}
          onChange={onRecipientsChange}
          inputType='text'
          placeholder={i18n.ink.notification.sendTest.brazeIdPlaceholder}
          validator={validator}
          invalidMessage={i18n.ink.notification.sendTest.invalidId}
        />
      </Form.Group>
    </>
  );
};

export default memo(BrazeChannelBody);
